import React from 'react';
import PropTypes from 'prop-types';

const PdfVisualizer = ({ data }) => {

  if(!data || data.length === 0 || !data[0].reportDownloadUri){
    return 'Bericht konnte nicht geladen werden';
  }

  return (
    <div style={{width:'100%', height: 'calc(100vh - 200px)'}}>
      <iframe
          src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${data[0].reportDownloadUri}#toolbar=0&scrollbar=0`}
          frameBorder="0"
          scrolling="auto"
          height="100%"
          width="100%"
      ></iframe>
    </div>
  );
};

PdfVisualizer.propTypes = {
  data: PropTypes.array.isRequired,
};

export default PdfVisualizer;
